var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"restrito"}},[_c('user-state',{scopedSlots:_vm._u([{key:"user",fn:function(ref){
var user = ref.user;
return [(user)?_c('div',[_c('profile',{attrs:{"user":user}})],1):_c('login')]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }